import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useExtratoFiscal = ({ dadosOs }) => {
  const [extrato, setExtrato] = useState({});
  const [listaReclamacao, setListaReclamacao] = useState([]);

  const { request: requestExtrato, data: dataExtrato, errors: errorsExtrato } = useApiClient();

  useEffect(() => {
    if (!dadosOs?.inscricaoEstadual) return;

    requestExtrato(apiRoutes.extratofiscal.extrato.consulta, { ie: dadosOs.inscricaoEstadual });
  }, [requestExtrato, dadosOs?.inscricaoEstadual]);

  useEffect(() => {
    if (dataExtrato?.result) {
      setExtrato(dataExtrato.result);
    }

    if (errorsExtrato) {
      toast.error(errorsExtrato.message);
    }
  }, [dataExtrato, errorsExtrato]);

  const {
    dadosContribuinte,
    obrigacoesAdvertencias,
    obrigacoesPendencias,
    obrigacoesSuspensas,
    debitosVencidos,
    debitoSuspenso,
    debitoAcordoCejuscFiscal,
    processoAdministrativoTributario,
    debitosVencer,
    debitosAcaoFiscalCobranca,
    dadosCrecenciamento,
    ocorrenciasFiscais,
    liminarLiberacao,
    regimeEspecial,
    parcelamento,
    pedidosVirtuais,
    itensDividaAtiva,
    debitosNaoPagosDividaAtiva,
  } = extrato;

  const patCriticado = processoAdministrativoTributario?.filter((processo) => processo.fg_critica === "S") ?? [];

  const patNaoCriticado = processoAdministrativoTributario?.filter((processo) => processo.fg_critica === "N") ?? [];

  const { request: requestReclamacao, data: dataReclamacao, errors: errorsReclamacao } = useApiClient();

  useEffect(() => {
    if (!dadosContribuinte?.cnpjCnpf) return;

    requestReclamacao(apiRoutes.nfp.reclamacao.listarReclamacao, { cnpj: dadosContribuinte.cnpjCnpf });
  }, [requestReclamacao, dadosContribuinte?.cnpjCnpf]);

  useEffect(() => {
    if (dataReclamacao) {
      setListaReclamacao(dataReclamacao.result);
    }

    if (errorsReclamacao && errorsReclamacao.message !== "Reclamação não existe") {
      toast.error(errorsReclamacao.message);
    }
  }, [dataReclamacao, errorsReclamacao]);

  const { request: requestDownload, data: dataDownload, errors: errorDownload } = useApiClient();

  const handleImprimirExtrato = useCallback(
    (ie, cnpj) => {
      requestDownload(apiRoutes.extratofiscal.extrato.imprimirExtrato, { ie, cnpj });
    },
    [requestDownload],
  );

  const handleDownload = useCallback(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });

      const url = URL.createObjectURL(file);

      window.open(url, "_blank", "width=800,height=800");
    }

    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return {
    dadosContribuinte,
    listaReclamacao,
    obrigacoesAdvertencias,
    obrigacoesPendencias,
    obrigacoesSuspensas,
    debitosVencidos,
    debitoSuspenso,
    debitoAcordoCejuscFiscal,
    patCriticado,
    debitosVencer,
    debitosAcaoFiscalCobranca,
    dadosCrecenciamento,
    ocorrenciasFiscais,
    liminarLiberacao,
    regimeEspecial,
    patNaoCriticado,
    parcelamento,
    pedidosVirtuais,
    itensDividaAtiva,
    debitosNaoPagosDividaAtiva,
    handleImprimirExtrato,
  };
};

export default useExtratoFiscal;
